var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500,307.2L242.8,50C189.9-2.9,103.3-3.1,50.1,50.1C-3.5,103.7-3.2,189.6,50,242.8L307.2,500L50,757.2c-52.9,52.9-53.1,139.5,0.1,192.7c53.6,53.6,139.5,53.3,192.7,0.1L500,692.8L757.2,950c52.9,52.9,139.5,53.1,192.7-0.1c53.6-53.6,53.3-139.5,0.1-192.7L692.8,500L950,242.8c52.9-52.9,53.1-139.5-0.1-192.7C896.3-3.5,810.4-3.2,757.2,50L500,307.2z",
    fill: "#ffffff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.b08de743700ab02dc42015ee54cc06af.svg";
export { ForwardRef as ReactComponent };